import { cssVarColors } from 'lib/cssSelector'
import { Styles } from 'react-jss'
const { lightGray } = cssVarColors

export const style: Styles = {
  photo: {},
  infoBlock: {},
  photoDark: {},
  infoBlockDark: {},
  arrow: {
    padding: '0 12px'
  },
  profileInfo: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backgroundColor: 'color-mix(in srgb, #334155 80%, transparent)',
    borderRadius: '8px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'color-mix(in srgb, #334155 95%, transparent)'
    },

    // margin: '0 20px',
    '& > $photo': {
      display: 'block',
      width: 40,
      height: 40,
      margin: '8px 12px',
      borderRadius: '50%',
      '& > img, & > svg': {
        backgroundColor: '#FFFFFF',

        width: 40,
        height: 40,
        borderRadius: '50%'
      }
    },
    '& > $infoBlock': {
      justifyContent: 'center',
      // margin: '0 20px 0 10px',
      display: 'flex',
      flexDirection: 'column',
      '& > div:first-child': {
        fontWeight: 'bold',
        lineHeight: '19px',
        fontSize: 15,
        letterSpacing: '0.01em',
        color: '#FAFAFA'
      },
      '& > div:last-child': {
        fontWeight: '500',
        lineHeight: '18px',
        fontSize: 13,
        letterSpacing: '0.03em',
        textTransform: 'capitalize',
        color: '#E6E6E6'
      }
    }
  },
  profileInfoDark: {
    margin: 0,
    '& > $photoDark': {
      width: 56,
      height: 56,
      border: '2px solid #286EFA',
      '& > img, & > svg': {
        width: 56,
        height: 56
      }
    },
    '& > $infoBlock': {
      '& > div:first-child': {
        fontWeight: '500',
        lineHeight: '21px',
        fontSize: 17,
        letterSpacing: '0.01em',
        color: '#080910'
      },
      '& > div:last-child': {
        textDecorationLine: 'underline',
        textTransform: 'none',
        color: '#989FA6'
      }
    }
  },
  '@media (max-width: 767px)': {
    hideOnXS: {},
    infoBlock: {
      '&$hideOnXS': {
        display: 'none'
      }
    }
  }
}
